import {
  applyMiddleware,
  combineReducers,
  createStore,
  Middleware
} from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { DeviceReducer, DeviceState } from "./device";
import { MenuReducer, MenuState } from "./menu";
import { DevicesMapReducer, DevicesMapState } from "./devicesMap";
import { NotificationReducer, NotificationState } from "./notification";
import { GraphQlReducer, GraphQlState } from "./graphQLStore";
import { SearchReducer, SearchState } from "./search";
import { PagingReducer, PagingReducerState } from "./paging";
import { RouteReducer, RouteState } from "./routes";
import {
  UserMetaReducer,
  UserMetaDataState,
  userMetaMiddleware
} from "./userMeta";
import { EnvReducer, Env, useEnv as envHook } from "./env";
import { SettingsState, SettingsReducer } from "./settings";
import { DesktopState, DesktopReducer } from "./desktop";
import {
  SettingsNavItemsReducer,
  SettingsNavItemsState
} from "./settingsNavItems";
import {
  DesktopDeviceSettingsReducer,
  DesktopDeviceSettingsState
} from "./desktopDeviceSettings";
import {
  DesktopDeviceSettingInheritanceReducer,
  DesktopDeviceSettingInheritanceState
} from "./desktopDeviceSettingInheritance";
import { DeviceLogsReducer, DeviceLogsState } from "./deviceLogs";
import {
  importDataMiddleware,
  ImportReducer,
  ImportReducerState
} from "./import";
import {
  ProvisionedDeviceSettingInheritanceReducer,
  ProvisionedDeviceSettingInheritanceState
} from "./provisionedDeviceSettingInheritance";
import { DeviceExportReducer, DeviceExportState } from "./deviceExport";

const initialState = {};

const createRootReducer = () =>
  combineReducers({
    device: DeviceReducer,
    devicesMap: DevicesMapReducer,
    desktopDeviceSettings: DesktopDeviceSettingsReducer,
    desktopDeviceSettingInheritance: DesktopDeviceSettingInheritanceReducer,
    settings: SettingsReducer,
    graph: GraphQlReducer,
    menu: MenuReducer,
    notifications: NotificationReducer,
    paging: PagingReducer,
    search: SearchReducer,
    route: RouteReducer,
    userMeta: UserMetaReducer,
    env: EnvReducer,
    desktop: DesktopReducer,
    settingsNavItems: SettingsNavItemsReducer,
    deviceLogs: DeviceLogsReducer,
    import: ImportReducer,
    provisionedDeviceSettingInheritance: ProvisionedDeviceSettingInheritanceReducer,
    exportDeviceInventory: DeviceExportReducer
  });

export interface State {
  device: DeviceState;
  devicesMap: DevicesMapState;
  settings: SettingsState;
  desktopDeviceSettings: DesktopDeviceSettingsState;
  desktopDeviceSettingInheritance: DesktopDeviceSettingInheritanceState;
  graph: GraphQlState;
  menu: MenuState;
  notifications: NotificationState;
  search: SearchState;
  paging: PagingReducerState;
  route: RouteState;
  userMeta: UserMetaDataState;
  env: Env;
  desktop: DesktopState;
  settingsNavItems: SettingsNavItemsState;
  deviceLogs: DeviceLogsState;
  exportDeviceInventory: DeviceExportState;
  import: ImportReducerState;
  provisionedDeviceSettingInheritance: ProvisionedDeviceSettingInheritanceState;
}

export default function configureStore() {
  const rootReducer = createRootReducer();

  const middleware: Middleware[] = [userMetaMiddleware, importDataMiddleware];

  const enhancers = [applyMiddleware(...middleware)];
  const devTools = composeWithDevTools({
    trace: true
  });

  return createStore(rootReducer, initialState, devTools(...enhancers));
}
export const useEnv = envHook;
export * from "./graphQLStore";
export * from "./localActions";
